const creditsDefaultState = {
    credits: null,
    initCredits: false
};

export default (state = creditsDefaultState, action) => {
    var tempState = {...state};

    switch (action.type) {
        case "SET_CREDITS":
            tempState.credits = action.credits
            return tempState;

        case "SET_INIT_CREDITS":
            tempState.initCredits = !tempState.initCredits;
            return tempState
        default:
            return tempState;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/credits.js